module.exports = "//static.hsappstatic.net/conversations-embed/static-1.24393/sass/messagesWidgetShell.sass"